import React from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RelatedEvents = ({ events }) => {
  const navigate = useNavigate();

  if (!events || events?.length === 0) {
    return null;
  }

  const getEventTypeIcon = (type) => {
    const iconMap = {
      workshop: 'Tool',
      conference: 'Users',
      webinar: 'Monitor',
      hackathon: 'Code',
      networking: 'MessageCircle',
      training: 'BookOpen',
      showcase: 'Award',
      meeting: 'Calendar'
    };
    return iconMap?.[type] || 'Calendar';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="font-semibold mb-4 flex items-center space-x-2">
        <Icon name="Calendar" size={18} />
        <span>Related Events</span>
      </h3>

      <div className="space-y-4">
        {events?.map((event) => (
          <div key={event?.id} className="border border-border rounded-lg p-4 hover:shadow-sm transition-shadow">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={getEventTypeIcon(event?.event_type)} size={16} className="text-primary" />
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-sm leading-tight mb-1">
                  {event?.title}
                </h4>
                
                <div className="flex items-center space-x-4 text-xs text-muted-foreground mb-2">
                  <div className="flex items-center space-x-1">
                    <Icon name="Calendar" size={12} />
                    <span>{format(new Date(event?.start_date), 'MMM dd')}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="Clock" size={12} />
                    <span>{format(new Date(event?.start_date), 'h:mm a')}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name={event?.is_virtual ? "Monitor" : "MapPin"} size={12} />
                    <span className="truncate">
                      {event?.is_virtual ? 'Virtual' : (event?.location || 'TBA')}
                    </span>
                  </div>
                </div>

                <p className="text-xs text-muted-foreground line-clamp-2 mb-3">
                  {event?.description}
                </p>

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-1 text-xs text-muted-foreground">
                    <Icon name="Users" size={12} />
                    <span>{event?.current_participants || 0} registered</span>
                  </div>
                  
                  <Button
                    variant="outline"
                    size="xs"
                    onClick={() => navigate(`/event-details-page?id=${event?.id}`)}
                  >
                    View Details
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 pt-4 border-t border-border">
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate('/events')}
          className="w-full"
        >
          <Icon name="Calendar" size={14} className="mr-2" />
          View All Events
        </Button>
      </div>
    </div>
  );
};

export default RelatedEvents;